import(/* webpackMode: "eager", webpackExports: ["LatestNews"] */ "/var/www/joy-awards-frontend-v3/src/app/[lang]/news/components/latest-news.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PressReleases"] */ "/var/www/joy-awards-frontend-v3/src/app/[lang]/news/components/press-releases.tsx");
